/**
 * @aw/cms-client @ v4.0.0
 * 
 * Copyright © 2020 American Well.
 * All rights reserved.
 * 
 * It is illegal to use, reproduce or distribute
 * any part of this Intellectual Property without
 * prior written authorization from American Well.
 */

import fetch from 'cross-fetch';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/**
 * The defaults used when calling {@link Client#init init}. Each of
 * these members can be passed to {@link Client#init init} to supply
 * new values.  The combination of the values creates a `context`,
 * which is used by subsequent function calls.
 *
 * For instance, if you intend to call {@link getBentoConfig} with
 * the same `product` value multiple times, you can provide that value
 * to `init`, and omit the key in {@link getBentoConfig}'s signature.
 *
 * @example
 * import { client, getBentoConfig } from '@aw/cms-client';
 * client.init({
 *   // all proxy calls will push locale=iw-IL
 *   locale: 'iw-IL',
 *   // single-product usage
 *   product: 'aehr-client',
 * });
 *
 * getBentoConfig({
 *   ehr: 'epic',
 *   role: 'PRACTITIONER',
 *   // override context value of `iw-IL` to spanish
 *   locale: 'es-US',
 * });
 *
 * @namespace defaults
 * @type {object}
 */
var defaults = {
  /**
   * the base url of the CMS Proxy service.
   *
   * @type {string}
   */
  url: 'https://api.cvg01.amwell.systems/aw-contentful-service/api/v1/cms/',

  /**
   * The `contentful` environment to target. ENUM of `master|qa|dev`, though arbitrary environments can be passed
   * if appropriately configured beforehand. If left blank, each instance of the cms proxy already will use a default environment:
   * dev-next uses dev, qa-next uses qa, staging and production use master.
   *
   * @type {string}
   */
  environment: 'master',

  /**
   * The key of the header used to override target environment
   *
   * @type {string}
   */
  environmentHeader: 'x-converge-cms-environment',

  /**
   * An authorization token to use, issued by a trusted JWT issuer. Used in authenticated calls
   *
   * @type {string}
   */
  token: null,
  // optional parameters that are common to each API call,
  // you can define them once during `init`, or override
  // these values per-method call by passing in values

  /**
   * If applicable, the locale of the request
   *
   * @type {string}
   */
  locale: 'en_US',

  /**
   * Generally a valid tenantId, eg: AMWL
   *
   * @type {string}
   */
  tenant: '',

  /**
   * Generally a valid brandingId, eg: default
   *
   * @type {string}
   */
  brandingId: '',

  /**
   * The product-id of the query, eg: `aehr-client`
   *
   * @type {string}
   */
  product: '',

  /**
   * The role of the view user, eg: PRACTITIONER
   *
   * @type {string}
   */
  role: '',

  /**
   * The ehrId associated with the query, if applicable. eg: epic
   *
   * @type {string}
   */
  ehr: '',

  /**
   * The topLevelApplicationId associated with the query, if applicable. eg: epic
   *
   * @type {string}
   */
  tla: '',

  /**
   * The SPA associated with the query, if applicable.
   *
   * @type {string}
   */
  spa: ''
};

var stripLeading = function stripLeading() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return str.replace(/^\//, '');
};

var stripTrailing = function stripTrailing() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return str.replace(/\/$/, '');
};

var normalizeLocale = function normalizeLocale(locale) {
  return locale.replace(/-/g, '_');
};
/**
 * The Core client, exported as a singleton from the package. See [init]{@link Client#init} for initialization instruction.
 *
 * @hideconstructor
 * @class
 *
 *
 *
 */


var Client = /*#__PURE__*/function () {
  function Client() {
    _classCallCheck(this, Client);
  }

  _createClass(Client, [{
    key: "init",
    value:
    /**
     * Initialize the client with configuration overrides on top of the [configuration defaults]{@link defaults}.
     *
     * @param {object} [args] kwArgs to provide access tokens, and other members described in {@link defaults}.
     *
     * @example
     * import { client } from '@aw/cms-client';
     * client.init({
     *   token: session.bearerToken,
     * });
     */
    function init() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // mix this new init context over the old context
      this.context = _objectSpread2(_objectSpread2(_objectSpread2({}, this.context), defaults), args);
      this.__initialized = true;
    }
  }, {
    key: "postProxy",
    value: function postProxy(endpoint, context, requestBody) {
      // ensure we always have at least `defaults`
      if (!this.__initialized) {
        this.init();
      }

      var url = new URL("".concat(stripTrailing(context.url), "/").concat(stripLeading(endpoint))); // build up the headers;

      var headers = _defineProperty({
        'content-type': 'application/json',
        Authorization: context.token ? "Bearer ".concat(context.token) : null
      }, context.environmentHeader, context.environment);

      return this.__fetch(url, headers, requestBody);
    }
  }, {
    key: "callProxy",
    value: function callProxy(endpoint, context) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      // ensure we always have at least `defaults`
      if (!this.__initialized) {
        this.init();
      } // check if there is a url indicator, or someone explicitly passed `preview: true`


      var urlParams = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
      params.preview = params.preview || context.preview || urlParams.has('cdnPreview');
      params.locale = normalizeLocale(params.locale || context.locale || this.context.locale); // build up the url

      var url = new URL("".concat(stripTrailing(context.url), "/").concat(stripLeading(endpoint)));
      Object.keys(params).forEach(function (key) {
        if (params[key] !== null && params[key] !== undefined) {
          url.searchParams.append(key, params[key]);
        }
      }); // build up the headers;

      var headers = _defineProperty({
        Authorization: context.token ? "Bearer ".concat(context.token) : null
      }, context.environmentHeader, context.environment);

      return this.__fetch(url, headers);
    }
  }, {
    key: "__fetch",
    value: function __fetch(url, headers, body) {
      var p = {
        method: body ? 'POST' : 'GET',
        headers: headers
      };

      if (body) {
        p.body = JSON.stringify(body);
      }

      return fetch(url, p).then(function (r) {
        return r.json();
      });
    }
  }]);

  return Client;
}();
/**
 * Exported singleton, providing the CMS initialization and configuration.
 *
 * Import the client into your application, and call `init`:
 *
 * ```
 * import { client } from '@aw/cms-client';
 * client.init({
 *    ...configuration
 * });
 * ```
 *
 *
 *
 */


var client = new Client();

var verify = function verify(fn) {
  if (!fn || !fn.meta) {
    throw new Error('Unsupported Client Method');
  }
};

var BatchRequest = /*#__PURE__*/function () {
  function BatchRequest() {
    _classCallCheck(this, BatchRequest);

    for (var _len = arguments.length, batch = new Array(_len), _key = 0; _key < _len; _key++) {
      batch[_key] = arguments[_key];
    }

    this.batch = batch.map(function (item) {
      if (!Array.isArray(item)) {
        return [item, {}];
      }

      return item;
    });
  }
  /**
   * Add an item to this batch request.
   *
   * @param {Function} fn the cms-client method to add to this batch
   * @param {Object} params additional parameters to pass to this specific request
   * @returns {BatchRequest}
   */


  _createClass(BatchRequest, [{
    key: "add",
    value: function add(fn) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      verify(fn);
      return _construct(BatchRequest, _toConsumableArray(this.batch).concat([[fn, params]]));
    }
    /**
     * Build up the compositeRequest from a list of batched items
     *
     * @private
     */

  }, {
    key: "__build",
    value: function __build() {
      var _this = this;

      this.compositeRequest = [];
      this.transforms = [];
      this.batch.forEach(function (item) {
        var _item = _slicedToArray(item, 2),
            fn = _item[0],
            params = _item[1];

        verify(fn); // extract the pertinent info from the metadata:

        var _fn$meta = fn.meta,
            endpoint = _fn$meta.endpoint,
            transform = _fn$meta.transform,
            props = _fn$meta.props; // add this function to the request

        _this.compositeRequest.push({
          method: endpoint,
          params: props(_objectSpread2(_objectSpread2({}, client.context), params))
        }); // keep the transform in sync with the request position


        _this.transforms.push(transform);
      });
    }
    /**
     * Execute the batch, and get back the results.
     *
     * @param {Object?} args additional k/v pairs to mix in as global context
     * @returns {Promise<Array>} The results of each batch item, in the order in which they were added
     */

  }, {
    key: "exec",
    value: function exec(args) {
      var _this2 = this;

      var context = _objectSpread2(_objectSpread2({}, client.context), args);

      var endpoint = context.token ? 'securedConfig' : 'publicConfig';

      this.__build();

      return client.postProxy("/aggregator/".concat(endpoint), context, {
        compositeRequest: this.compositeRequest
      }).then(function (response) {
        var payloads = response.compositeResponse;

        if (payloads && payloads.length !== _this2.compositeRequest.length) {
          throw new Error('Composite Request vs Response length mismatch');
        }

        return payloads.map(function (item, idx) {
          item.data = _this2.transforms[idx](item);

          if (item.error) {
            // return the full item with error so it is visible.
            return item;
          } // otherwise just return the transformed data


          return item.data;
        });
      });
    }
  }]);

  return BatchRequest;
}();

/**
 * Create a batched request for multiple endpoints in the CMS Proxy,
 * collecting multiple types of documents in order, and resolving to
 * the payloads from each of the ordered batch items.
 *
 * Pass `cms-client` exported functions as arguments, or as a tuple of `[method, params]`
 * to supply additional method-specific parameters.
 *
 * Call `add(method, params)` on the returned object to add more items to the batch
 *
 * Call `exec` on the batch object to trigger the request, returning a promise that
 * resolves to the aggregated payload.
 *
 * Each batched item will have the same transformations called on the payload as the
 * standalone method, so the data will take the same form either way.
 *
 * @example
 * import { batch, getBentoConfig, getTriageQuestions } from '@aw/cms-client';
 * batch(getBentoConfig, getTriageQuestions).exec().then(data => {
 *  // data[0] is getBentoConfig data
 *  // data[1] is getTriageQuestions data
 * });
 * @param  {...any} args any number of methods or tuples to include in the batch
 * @returns {BatchRequest} an object/DSL for mutating and executing the batch
 */

var batch = function batch() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return _construct(BatchRequest, args);
};

var createMethod = function createMethod(meta) {
  var api = function api(args) {
    var context = _objectSpread2(_objectSpread2({}, client.context), args);

    return client.callProxy(meta.endpoint, context, meta.props(context)).then(meta.transform);
  };

  api.meta = meta;
  return api;
};

/**
 * Get a bento configuration.
 *
 * Args are only passed to override values set via `init`
 *
 * @param {object} [args] kwArgs to be mixed with init values
 * @param {string} [args.product] The product ID to use
 * @param {string} [args.tenant] The tenant key to use
 * @param {string} [args.role] The use role to use
 * @param {string} [args.ehr] The ehrId to use
 * @param {string} [args.locale] the locale to use, if applicable
 * @param {boolean} [args.preview] preview flag
 * @param {string} [args.serviceLine] the serviceLine to use, if applicable
 * @param {string} [args.specialty] the specialty which the provider belongs to
 * @param {string} [args.isFallback] fallback Flag
 * @returns {Promise<*>} that resolves with the bento configuration object
 */

var getBentoConfig = createMethod({
  transform: function transform(result) {
    var _result$data$;

    return (result === null || result === void 0 ? void 0 : result.data) && ((_result$data$ = result.data[0]) === null || _result$data$ === void 0 ? void 0 : _result$data$.bentoConfig) || {};
  },
  endpoint: 'bento-configs',
  props: function props(context) {
    return {
      tenant: context.tenant,
      product: context.product,
      configurationType: context.role,
      ehrId: context.ehrId || context.ehr,
      locale: context.locale,
      preview: context.preview,
      serviceLine: context.serviceLine,
      specialty: context.specialty,
      isFallback: context.isFallback
    };
  }
});

/**
 * Fetch Classification
 *
 * @param {object} args
 * @param {string} [args.preview] the preview
 * @param {string} [args.locale] a language to use
 * @param {string} [args.tenant] the tenant ID to use
 * @param {string} [args.classification] classification ID
 * @returns {Promise<array>} the contentful response
 */

var getClassification = createMethod({
  transform: function transform(result) {
    return (result === null || result === void 0 ? void 0 : result.data) || [];
  },
  endpoint: 'classification',
  props: function props(context) {
    return {
      preview: context.preview,
      locale: context.locale,
      tenant: context.tenant,
      classification: context.classification
    };
  }
});

var getIntake = createMethod({
  transform: function transform(result) {
    return (result === null || result === void 0 ? void 0 : result.data) || [];
  },
  endpoint: 'intake-configuration',
  props: function props(context) {
    return {
      tenant: context.tenant,
      product: context.product,
      locale: context.locale,
      preview: context.preview,
      serviceLine: context.serviceLine
    };
  }
});

/**
 * Fetch medical conditions
 *
 * @param {object} args
 * @param {string} [args.tenant] the tenant Id to use
 * @param {string} [args.product] the product-id to use
 * @param {string} [args.locale] a locale to use
 * @param {boolean} [args.preview] preview flag
 * @param {string} [args.serviceLine] service line
 * @returns {Promise<array>} list of conditions for this product/tenant
 */

var getMedicalConditions = createMethod({
  transform: function transform(result) {
    return (result === null || result === void 0 ? void 0 : result.data) || [];
  },
  endpoint: 'medical-conditions',
  props: function props(context) {
    return {
      tenant: context.tenant,
      product: context.product,
      locale: context.locale,
      preview: context.preview,
      serviceLine: context.serviceLine
    };
  }
});

/**
 * Fetch PDF template
 *
 * @param {object} args
 * @param {string} [args.product] the product ID to use
 * @param {string} [args.tenant] the tenant ID to use
 * @param {string} [args.format] a file format to use
 * @param {string} [args.type] a type to use
 * @param {string} [args.locale] a language to use
 * @returns {Promise<array>} pdf template for this product/tenant
 */

var getPDFTemplate = createMethod({
  transform: function transform(result) {
    return (result === null || result === void 0 ? void 0 : result.data) || [];
  },
  endpoint: 'pdf',
  props: function props(context) {
    return {
      product: context.product,
      tenant: context.tenant,
      format: context.format,
      type: context.type,
      language: context.locale,
      preview: context.preview
    };
  }
});

/**
 * Get support contact for particular tenant and top level application
 *
 * @param {object} args - Contentful queries for support contact
 * @param {boolean} [args.preview] preview flag
 * @param {string} [args.tenant] Tenant id
 * @param {string} [args.product] product id. Deprecated and to be removed in near future. Use tla instead
 * @param {string} [args.tla] The top level application id to use, if applicable
 * @param {string} [args.locale] The locale to use, if applicable
 * @param {string} [args.brandingId] The branding id to use, if applicable
 * @param {boolean} [args.preview] preview flag
 * @return {Promise<object>} Cms proxy result
 */

var getBranding = createMethod({
  transform: function transform(result) {
    return (result === null || result === void 0 ? void 0 : result.data) || {};
  },
  endpoint: 'branding',
  props: function props(context) {
    return {
      tenant: context.tenant,
      product: context.product,
      locale: context.locale,
      preview: context.preview,
      tla: context.tla,
      brandingId: context.brandingId
    };
  }
});

/**
 * Fetch feedback questions
 *
 * @param {object} args
 * @param {string} [args.tenant] the tenant Id to use
 * @param {string} [args.userType] role of the user
 * @param {string} [args.product] the product-id to use
 * @param {string} [args.locale] a locale to use
 * @param {boolean} [args.preview] preview flag
 * @returns {Promise<array>} list of conditions for this product/tenant
 */

var getFeedback = createMethod({
  transform: function transform(result) {
    return (result === null || result === void 0 ? void 0 : result.data) || [];
  },
  endpoint: 'feedback',
  props: function props(context) {
    return {
      userType: context.role,
      tenant: context.tenant,
      product: context.product,
      locale: context.locale,
      preview: context.preview
    };
  }
});

/**
 * Gets a legal document
 *
 * These are some legal documents:
 *
 *  * Terms of Use
 *  * Privacy Policy
 *  * NOPP
 *
 * @param {Object} args - Contentful queries for legal document
 * @param {string} [args.documentType] the type of document to fetch
 * @param {Boolean} [args.preview] if preview document.
 * @param {string} [args.tenant] Tenant id.
 * @param {string} [args.product] The product's id.
 * @param {string} [args.locale] the locale to use, if applicable
 * @param {boolean} [args.preview] preview flag
 * @param {location} [args.location] Location is applicable to identify a specific document
 * @param {string} [args.role] The user role to use (PATIENT or PRACTITIONER)
 * @param {string} [args.brandingId] The branding id to use, if applicable
 * @return {Promise<array>} Contentful query results
 */

var getLegalDocuments = createMethod({
  transform: function transform(response) {
    return (response === null || response === void 0 ? void 0 : response.data) || [];
  },
  endpoint: 'legal-documents',
  props: function props(context) {
    var params = {
      tenant: context.tenant,
      product: context.product,
      serviceLine: context.serviceLine,
      locale: context.locale,
      preview: context.preview,
      documentType: context.documentType,
      location: context.location || [],
      brandingId: context.brandingId
    };

    if (context.role) {
      params.configurationType = context.role;
    }

    return params;
  }
});

/**
 * Gets a top-level application config
 *
 * @param {Object} args - Contentful queries for top-level applications
 * @param {string} [args.tenant] Tenant id.
 * @param {string} [args.uri] TLA config URI.
 * @param {string} [args.tla] Top Level Application id.
 * @param {string} [args.locale] the locale to use, if applicable
 * @param {boolean} [args.preview] preview flag
 * @return {Promise<array>} Contentful query results
 */

var getApplicationConfig = createMethod({
  transform: function transform(response) {
    return (response === null || response === void 0 ? void 0 : response.data) || [];
  },
  endpoint: 'top-level-application',
  props: function props(context) {
    return {
      tenant: context.tenant,
      topLevelApplication: context.tla,
      uri: context.uri,
      locale: context.locale,
      preview: context.preview
    };
  }
});

/**
 * Get triage questions for a product/tenant
 *
 * @param {Object} args kwArgs to pass in
 * @param {string} [args.tenant] the tenant-id
 * @param {string} [args.product] the product-id
 * @param {string} [args.locale] the locale to use, if applicable
 * @param {boolean} [args.preview] preview flag
 * @param {string} [args.serviceLine] Optional. service line
 * @returns {Promise<any>} the contentful response
 */

var getTriageQuestions = createMethod({
  transform: function transform(r) {
    return r;
  },
  endpoint: 'intake-questions',
  props: function props(context) {
    return {
      product: context.product,
      tenant: context.tenant,
      locale: context.locale,
      preview: context.preview,
      serviceLine: context.serviceLine
    };
  }
});

/**
 * Get questions configuration by type for a tla/tenant
 *
 * @param {string} [args.type] the question type
 * @param {string} [args.tla] the top level app id
 * @param {string} [args.tenant] the tenant-id
 * @param {string} [args.locale] the locale to use, if applicable
 * @param {boolean} [args.preview] preview flag
 * @param {string} [args.serviceLine] Optional. service line
 * @returns {Promise<any>} the contentful response
 */

var getQuestionsConfiguration = createMethod({
  transform: function transform(r) {
    return r && r.data || [];
  },
  endpoint: 'questions-configuration',
  props: function props(context) {
    return {
      type: context.type,
      tla: context.tla,
      tenant: context.tenant,
      locale: context.locale,
      preview: context.preview,
      serviceLine: context.serviceLine
    };
  }
});

/**
 * Get genders for particular tenant
 *
 * @param {object} args - Contentful queries for genders
 * @param {boolean} [args.preview] If preview genders
 * @param {string} [args.tenant] Tenant id
 * @param {string} [args.locale] The locale to use, if applicable
 * @return {Promise<object>} Contentful query results
 */

var getGenders = createMethod({
  transform: function transform(response) {
    return (response === null || response === void 0 ? void 0 : response.data) || {};
  },
  endpoint: 'genders',
  props: function props(context) {
    return {
      tenant: context.tenant,
      preview: context.preview,
      locale: context.locale
    };
  }
});

/**
 * Get provider insight for particular tenant, product and service line
 *
 * @param {object} args - Contentful queries for provider insight
 * @param {boolean} [args.preview] If preview content
 * @param {string} [args.product] Product id
 * @param {string} [args.serviceLine] Service Line id
 * @param {string} [args.tenant] Tenant id
 * @param {string} [args.locale] The locale to use, if applicable
 * @return {Promise<object>} Contentful query results
 */

var getProviderInsight = createMethod({
  transform: function transform(response) {
    return (response === null || response === void 0 ? void 0 : response.data) || {};
  },
  endpoint: 'provider-insight',
  props: function props(context) {
    return {
      tenant: context.tenant,
      product: context.product,
      serviceLine: context.serviceLine,
      preview: context.preview,
      locale: context.locale
    };
  }
});

/**
 * Get virtual background image options for particular tenant
 *
 * @param {object} args - Contentful queries for genders
 * @param {boolean} [args.preview] If preview virtual_background
 * @param {string} [args.tenant] Tenant id
 * @param {string} [args.locale] The locale to use, if applicable
 * @return {Promise<object>} Contentful query results
 */

var getVirtualBackgrounds = createMethod({
  transform: function transform(response) {
    return (response === null || response === void 0 ? void 0 : response.data) || {};
  },
  endpoint: 'virtualBackground',
  props: function props(context) {
    return {
      tenant: context.tenant,
      preview: context.preview,
      locale: context.locale
    };
  }
});

/**
 * Get support contact for particular tenant and top level application
 *
 * @param {object} args - Params for support contact query in the cms proxy.
 *
 * @param {string} [args.tenant] Required. Tenant id.
 * @param {string} [args.tla] Optional. The top level application id to use.
 * @param {string} [args.locale] Optional. The locale to use. If not passed, the default in the cms proxy is en-US.
 * @param {boolean} [args.preview] Optional. Preview flag defaults to false if not provided and would not return unpublished content.
 *
 * @return {Promise<object>} Cms proxy result
 */

var getSupportContact = createMethod({
  transform: function transform(response) {
    return (response === null || response === void 0 ? void 0 : response.data) || {};
  },
  endpoint: 'support-contact',
  props: function props(context) {
    return {
      tenant: context.tenant,
      tla: context.tla,
      preview: context.preview,
      locale: context.locale
    };
  }
});

/**
 * Get tenant configurations for SPA and TLA from the cms proxy.
 *
 * @param {object} args - Params for tenant configs query in the cms proxy.
 *
 * @param {string} [args.tenant] Tenant id.
 * @param {string} [args.tla] Optional. The top level application id in contentful.
 * @param {string} [args.spa] Optional. SPA id in contentful.
 * @param {string} [args.locale] Optional. The locale defaults to en-US if not provided.
 * @param {boolean} [args.preview] Optional. Preview flag defaults to false if not provided and would not return unpublished content.
 *
 * @return {Promise<object>} Cms proxy result
 */

var getTenantConfigs = createMethod({
  transform: function transform(response) {
    return (response === null || response === void 0 ? void 0 : response.data) || {};
  },
  endpoint: 'tenant-configs',
  props: function props(context) {
    return {
      preview: context.preview,
      locale: context.locale,
      tenant: context.tenant,
      spa: context.spa,
      tla: context.tla
    };
  }
});

/**
 * Fetch Service Line
 *
 * @param {object} args
 * @param {string} [args.preview] the preview
 * @param {string} [args.tenant] the tenant ID to use
 * @param {string} [args.locale] a language to use
 * @param {string} [args.serviceLine] Optional. service line
 * @returns {Promise<array>} the contentful response
 */

var getServiceLine = createMethod({
  transform: function transform(result) {
    return (result === null || result === void 0 ? void 0 : result.data) || [];
  },
  endpoint: 'serviceline',
  props: function props(context) {
    return {
      tenant: context.tenant,
      preview: context.preview,
      locale: context.locale,
      serviceLine: context.serviceLine
    };
  }
});

/**
 * Fetch reporting events configuration
 *
 * Note: This endpoint is linked to the CELConfig object in the content model
 *
 * @param {object} args
 * @param {string} [args.tla] the top level application to search by
 * @param {boolean} [args.preview] preview flag
 * @returns {Promise<any>} array matching CELConfig based on the tla parameter
 */

var getReportingConfig = createMethod({
  transform: function transform(result) {
    return (result === null || result === void 0 ? void 0 : result.data) || [];
  },
  endpoint: 'cel-config',
  props: function props(context) {
    return {
      tla: context.tla,
      preview: context.preview
    };
  }
});

/**
 * Get application tiles
 *
 * @param {object} args - Contentful queries for application-tiles
 * @param {boolean} [args.preview] Preview flag
 * @param {string} [args.tileIds] List of tile Ids
 * @param {string} [args.locale] The locale to use, if applicable
 * @return {Promise<object>} Contentful query results
 */

var getApplicationTiles = createMethod({
  transform: function transform(response) {
    return (response === null || response === void 0 ? void 0 : response.data) || {};
  },
  endpoint: 'application-tiles',
  props: function props(context) {
    return {
      tileIds: context.tileIds,
      preview: context.preview,
      locale: context.locale
    };
  }
});

/**
 * Get partners and their programs
 *
 * @param {object} args - Contentful queries for partners and programs
 * @param {string} [args.partnerIds] List of partner id's as a comma delimited list
 * @param {string} [args.programIds] List of program id's as a comma delimited list
 * @param {boolean} [args.preview] Preview flag
 * @param {string} [args.locale] The locale to use, if applicable
 * @return {Promise<object>} Contentful query results
 */

var getPartnersAndPrograms = createMethod({
  transform: function transform(response) {
    return (response === null || response === void 0 ? void 0 : response.data) || {};
  },
  endpoint: 'partners-programs',
  props: function props(context) {
    return {
      partnerIds: context.partnerIds,
      programIds: context.programIds,
      preview: context.preview,
      locale: context.locale
    };
  }
});

/**
 * Get visit type configuration by type for a tenant
 *
 * @param {string} [args.tenant] the tenant-id
 * @param {string} [args.locale] the locale to use, if applicable
 * @param {boolean} [args.preview] preview flag
 * @param {string} [args.visitTypeIds] Optional. visit type ids comma separated
 * @returns {Promise<any>} the contentful response
 */

var getVisitTypeConfiguration = createMethod({
  transform: function transform(r) {
    return r && r.data || [];
  },
  endpoint: 'visit-type-configuration',
  props: function props(context) {
    return {
      locale: context.locale,
      preview: context.preview,
      tenant: context.tenant,
      visitTypeIds: context.visitTypeIds
    };
  }
});

/**
 * Get SPA Translations for an application and per tenant
 *
 * @param {object} args - Contentful queries for genders
 * @param {boolean} [args.preview] If preview virtual_background
 * @param {string} [args.tenant] Tenant id
 * @param {string} [args.locale] The locale to use
 * @param {string} [args.application] The SPA ID.
 * @return {Promise<object>} Contentful query results
 */

var getTranslation = createMethod({
  transform: function transform(response) {
    return (response === null || response === void 0 ? void 0 : response.data) || {};
  },
  endpoint: 'spa-translation',
  props: function props(context) {
    return {
      preview: context.preview,
      locale: context.locale,
      tenant: context.tenant,
      application: context.application
    };
  }
});

var getDashboard = createMethod({
  transform: function transform(r) {
    return r && r.data || [];
  },
  endpoint: 'dashboard-widget-customization',
  props: function props(context) {
    return {
      tenant: context.tenant
    };
  }
});

var transform = function transform(result) {
  return (result === null || result === void 0 ? void 0 : result.data) || [];
};
/**
 * Method for aehr client that returns branding/legal documents/support contacts in a single http call.
 *
 * @returns {Promise<array>} Aggregated response that contains branding/legal documents/support contacts response
 * The parameters, required or optional, of each method are completely defined by respective API in the CMS proxy.
 *
 * Supports "shared global parameters" from client.init({ product: 'aehr-client', tenant: 'AMWL' });
 * Such params will be used in each individual method without the need to specify them again.
 *
 * @param args client arguments
 * @deprecated use `batch(getBranding, getLegalDocuments, getSupportContact)` instead
 */


var aehrPublicConfig = function aehrPublicConfig(args) {
  var context = _objectSpread2(_objectSpread2({}, client.context), args);

  var request = {
    aehrRequest: {
      branding: {
        tenant: context.tenant,
        product: context.product,
        tla: context.tla,
        preview: context.preview,
        locale: context.locale
      },
      'legal-documents': {
        tenant: context.tenant,
        product: context.product,
        documentType: context.documentType,
        preview: context.preview,
        locale: context.locale
      },
      'support-contact': {
        tenant: context.tenant,
        tla: context.tla,
        preview: context.preview,
        locale: context.locale
      }
    }
  };
  return client.postProxy('/aehr/publicConfig', context, request).then(transform);
};

export { aehrPublicConfig, batch, client, getApplicationConfig, getApplicationTiles, getBentoConfig, getBranding, getClassification, getDashboard, getFeedback, getGenders, getIntake, getLegalDocuments, getMedicalConditions, getPDFTemplate, getPartnersAndPrograms, getProviderInsight, getQuestionsConfiguration, getReportingConfig, getServiceLine, getSupportContact, getTenantConfigs, getTranslation, getTriageQuestions, getVirtualBackgrounds, getVisitTypeConfiguration };
